<template>
  <div>
    <x-toolbar
      :title="pageTitle"
      :tabs="hasTabs"
      :full-width="true"
      :extension="hasTabs"
    >
      <template
        v-if="hasTabs"
        #extension
      >
        <v-tabs
          v-model="tab"
          background-color="primary lighten-1"
          grow
        >
          <v-tabs-slider
            color="accent"
          />
          <v-tab
            v-for="item of tabItems"
            :key="item.label"
          >
            {{ $t('tasks.locationTransfer.navigation.' + item.label) }}
          </v-tab>
        </v-tabs>
      </template>
    </x-toolbar>
    <template v-if="details">
      <template v-if="assignable">
        <TaskAssignButton
          :loading="loading"
          @assign="assign"
        />
      </template>
      <template v-if="hasTabs">
        <v-tabs-items v-model="tab">
          <v-tab-item
            v-for="item of tabItems"
            :key="item.label"
          >
            <component
              :is="item.component"
              :api="API"
              :task-info="taskInfo"
            />
          </v-tab-item>
        </v-tabs-items>
      </template>
      <template v-else>
        <LocationTransferAssignment
          :task-info="taskInfo"
        />
      </template>
    </template>
    <template v-else>
      <v-progress-linear
        indeterminate
      />
    </template>
  </div>
</template>

<script>
    import {TaskLocationTransferAPI as API} from "@/api/TaskLocationTransferAPI";
    import {tabTitle} from "@/utils/string";
    import {ACLMixin} from "@/app/mixins/ACLMixin";
    import {TaskStateMixin} from "@/app/mixins/TaskStateMixin";
    import {TaskAssignMixin} from "@/app/mixins/TaskAssignMixin";
    import {EventsListenerMixin} from "@/app/mixins/EventsListenerMixin";
    import {BarcodeListenerMixin} from "@/app/mixins/BarcodeListenerMixin";
    import {RouteParamsMapperMixin} from "@/app/mixins/RouteParamsMapperMixin";
    import {taskNames, taskTypes} from "@/enum/task_type";
    import TaskDefaultOverview from "@/app/tasks/components/TaskDefaultOverview.component";
    import LocationTransferAssignment from "@/app/tasks/locationTransfer/components/LocationTransferAssignment.component";
    import LocationsTransferTransfer from "@/app/tasks/locationTransfer/components/LocationTransferTransfer.component";
    import {assign} from "@/utils/object";
    import TaskAssignButton from "@/app/tasks/components/TaskAssignButton.component";

    export default {
        name: "LocationTransferShow",
        components: {LocationTransferAssignment, TaskAssignButton},
        mixins: [ACLMixin, TaskStateMixin, TaskAssignMixin, EventsListenerMixin, BarcodeListenerMixin, RouteParamsMapperMixin],
        data: () => ({
            API: API,
            loading: false,
            type: taskTypes.LOCATION_TRANSFER,
            details: null,
            tab: null,
            ready: false
        }),
        computed: {
            events: function () {
                return {
                    'onBarcodeRead': this.activateTab,
                };
            },
            typeName: function () {
                return this.$t(taskNames[this.type]);
            },
            pageTitle: function () {
                const title = '#' + this.taskId + ' ' + this.typeName;
                if (!this._inactive) {
                    document.title = tabTitle(title);
                }
                return title;
            },
            taskInfo: function () {
                return {
                    details: this.details,
                    tab: this.tab,
                    taskId: this.taskId
                };
            },
            tabItems: function () {
                return [{
                    label: 'assignment',
                    component: LocationTransferAssignment
                }]
                    .concat(
                        (
                            this.isStorekeeper || this.isChief
                        ) ? [{
                            label: 'locationTransfer',
                            component: LocationsTransferTransfer
                        }] : [])
                    .concat(
                        (
                            this.isOpenState && (
                                (this.isStorekeeper && this.assignedToCurrentUser && this.isInProgress) || this.isChief
                            )
                        ) ? [{
                            label: 'finish',
                            component: TaskDefaultOverview
                        }] : []);
            },
            hasTabs: function () {
                return this.tabItems.length > 1;
            }
        },
        createdOrActivated: function (lifeCycleHook) {
            this.getTask(lifeCycleHook);
        },
        methods: {
            getTask: function (lifeCycleHook) {
                return API.get(this.taskId, true)
                    .then(response => {
                        if (lifeCycleHook === this.LifeCycleHook.CREATED) {
                            this.details = response.data;
                        } else {
                            assign(this.details, response.data);
                        }
                        this.ready = true;
                    }).catch(err => {
                        this.snack(err);
                        this.$router.push('/');
                    });
            }
        }
    };
</script>

<style scoped>

</style>
